module.exports = __webpack_public_path__ + "static/assets/42115eaf3865efbbda1feaffc63c9a33.png";